import { Month } from '../../../../domain/util/date';
import { SubCategory } from '../../../../domain/categories';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createCategoryOutflowSelector } from '../selectors/monthBudget';

const useCategoryOutflows = (month: Month, uuid: SubCategory['uuid']) => {
	const outflowsSelector = useMemo(() => {
		return createCategoryOutflowSelector(month.year, month.month, uuid);
	}, [month.year, month.month, uuid]);
	return useSelector(outflowsSelector);
};

export default useCategoryOutflows;